import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import {RouterChangeService} from '../../core/services/router-change.service';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css'],
  standalone: false
})
export class SideBarComponent implements OnInit {

  activeTab = '';
  activeUrl = '';

  menuOptions = [
    {label: 'Home', icon: 'las la-chart-bar', link: 'home', show: true, activeURLs: ['/home']},
    {
      label: 'Users',
      icon: 'las la-user-cog',
      link: '/users',
      show: true,
      activeURLs: ['/users', '/organizations', '/quotes', '/claim', '/podcasts']
    },
    {
      label: 'Marketplace',
      icon: 'las la-store',
      link: '/marketplace/books',
      show: true,
      activeURLs: ['/marketplace/projects', '/marketplace/books', '/marketplace/satire', '/marketplace/requests']
    },
    {
      label: 'E-commerce',
      icon: 'las la-shopping-bag',
      link: '/ecommerce/orders',
      show: true,
      activeURLs: ['/ecommerce/categories', '/ecommerce/products', '/ecommerce/orders']
    },
    {
      label: 'Entities',
      icon: 'las la-user-friends',
      link: '/entities',
      show: true,
      activeURLs: ['/entities', '/super-categories', '/categories', '/rating-categories']
    },
    {label: 'Twitter', icon: 'lab la-twitter', link: '/twitter/golden-list', show: true, activeURLs: ['/twitter']},
    {label: 'Surveys', icon: 'las la-poll', link: '/surveys', show: true, activeURLs: ['/surveys']},
    {
      label: 'Management',
      icon: 'las la-tasks',
      link: '/memberships',
      show: true,
      activeURLs: ['/memberships', '/management/score-models']
    },
    {
      label: 'CMS',
      icon: 'las la-server',
      link: '/banners',
      show: true,
      activeURLs: ['/banners', '/icons', '/nfts-collection', '/cms/hindutva-laboratory']
    },
    {
      label: 'Communication',
      icon: 'las la-handshake',
      link: '/news',
      show: true,
      activeURLs: ['/news', '/suggestions']
    },

  ];

  constructor(
    private router: Router,
    private routerChangeService: RouterChangeService
  ) {
    this.routerChangeService.activeRoute.subscribe((e) => {
      this.activeUrl = e.urlAfterRedirects || e.url;
    });
  }

  ngOnInit(): void {
    this.activeUrl = this.router.url;
    this.activeTab = sessionStorage.getItem(environment.activeTab);
  }

  changeTab(tab: string): void {
    this.activeTab = tab;
    sessionStorage.setItem(environment.activeTab, tab);
  }

  isActive(activeUrls: string[] = [], searchString: string = ''): boolean {
    const currentPath = searchString.split(/[?#]/)[0];
    return activeUrls.some(item => currentPath === item || currentPath.startsWith(`${item}/`));
  }
}
